import { render, staticRenderFns } from "./IpSet.vue?vue&type=template&id=dd6277b6&scoped=true"
import script from "./IpSet.vue?vue&type=script&lang=js"
export * from "./IpSet.vue?vue&type=script&lang=js"
import style0 from "./IpSet.vue?vue&type=style&index=0&id=dd6277b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6277b6",
  null
  
)

export default component.exports